<script setup>
defineProps({
  title: {
    type: String,
  },
  summary: {
    type: String,
  },
  cards: {
    type: Array,
  },
  categoryUrl: {
    type: String,
  },
  showArticleSummaries: {
    type: Boolean,
  },
  showArticleTopics: {
    type: Boolean,
  },
})
</script>

<!-- Article Listing Block -->
<template>
  <div class="mb-10">
    <div class="container-fluid">
      <div class="flex flex-col xl:flex-row gap-15 xl:gap-11.25 3xl:max-w-block-wide m-auto">
        <div
          v-if="title || summary"
          class="xl:max-w-[20%]"
        >
          <div
            class="prose"
          >
            <div class="h3 min-w-50">
              {{ title }}
            </div>
            <p class="text-wrap break-all">
              {{ summary }}
            </p>
            <UButton
              v-if="categoryUrl"
              class="no-underline"
              :to="useCmsUrl(categoryUrl)"
              :locale="false"
            >
              More from this category
            </UButton>
          </div>
        </div>
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-7.5">
          <div
            v-for="card in cards"
            :key="card.id"
            class="flex flex-col card-shadow rounded-xl pb-10 2xl:pb-11.25"
          >
            <ULink
              v-if="card.thumbnailImage || card.headerImage"
              :to="useCmsUrl(card.articleUrl)"
              :locale="false"
              class="text-primary"
              :aria-label="card.title"
            >
              <NuxtImg
                provider="fastlyAprimo"
                class="rounded-t-xl w-full aspect-[356/200] object-cover m-0"
                :src="card.thumbnailImage?.imageUrl ?? card.headerImage?.imageUrl"
                loading="lazy"
                :width="card.thumbnailImage?.width ?? card.headerImage?.width ?? 356"
                :height="card.thumbnailImage?.height ?? card.headerImage?.height ?? 200"
                fit="cover"
                sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 360px"
                :alt="card.thumbnailImage?.imageAltText
                  ?? card.headerImage?.imageAltText
                  ?? 'article image'"
              />
            </ULink>
            <div class="grow prose px-7.5 2xl:px-11.25 pt-7">
              <h2
                v-if="card.title"
                class="h4"
              >
                <ULink
                  :to="useCmsUrl(card.articleUrl)"
                  :locale="false"
                  class="text-primary no-underline hover:underline"
                >
                  {{ card.title }}
                </ULink>
              </h2>
              <p
                v-if="showArticleSummaries"
                v-html="card.description"
              />
            </div>
            <div
              v-if="showArticleTopics && card.category"
              class="prose"
            >
              <ULink
                :to="useCmsUrl(card.categoryUrl)"
                :locale="false"
                class="px-7.5 2xl:px-11.25 italic text-med-dark-gray font-normal no-underline"
              >
                {{ card.category }}
              </ULink>
            </div>
          </div>
        </div>
      </div>
      <div>
        <slot name="pagination" />
      </div>
    </div>
  </div>
</template>
